<template>
  <div id="EditPhoneCodeView" class="edit-phone-code-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <IcgLeftNav></IcgLeftNav>
        <b-col>
          <b-row>
            <PhoneCodesTabs></PhoneCodesTabs>
          </b-row>
          <b-row>
            <b-col class="add-phone-code p-0">
              <b-form id="add-phone-code-form" @submit.prevent="save" class="add-form pl-3 pr-3 p-sm-4 pl-sm-5">
                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Page title">
                      <b-form-input v-model="code.pageTitle" :disabled="isLoading" required></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Page description" description="Meta tag page description">
                      <b-form-textarea v-model="code.pageDescription" :disabled="isLoading" :rows="2" required></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Keywords">
                      <b-form-input v-model="code.keywords" :disabled="isLoading" required></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="8">
                    <b-form-group label="Country name">
                      <b-form-input v-model="code.countryName" :disabled="isLoading" required></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="2">
                    <b-form-group label="Iso-2">
                      <b-form-input v-model="code.id" maxlength="2" required disabled></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Body title">
                      <b-form-input v-model="code.bodyTitle" :disabled="isLoading"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Override h1" description="Use this field to create a h1 tag on top of the page">
                      <b-form-input v-model="code.overrideh1" :disabled="isLoading"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="12">
                    <b-form-group label="Body description" description="Html content article">
                      <b-form-textarea v-model="code.body" :disabled="isLoading" :rows="12" required></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row class="submit">
                  <b-col cols="12" sm="12">
                    <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Save</b-button>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import IcgLeftNav from '@/components/layout/IcgLeftNav'
import Header from '@/components/layout/Header'
import PhoneCodesTabs from '@/components/PhoneCodesTabs'
export default {
  name: 'PhoneCodesAdd',
  components: {
    Header,
    PhoneCodesTabs,
    IcgLeftNav
  },
  async mounted () {
    if ('id' in this.$route.params) {
      await this.fetchPhoneCodeById({
        id: this.$route.params.id,
        locale: 'en'
      })
      let newCode = this.$store.state.icg.newPhoneCode
      this.code = Object.assign({}, newCode)
    } else {
      this.$router.push({name: 'phoneCodes'})
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  methods: {
    ...mapActions({
      'savePhoneCode': 'icg/savePhoneCode',
      'fetchPhoneCodeById': 'icg/fetchPhoneCodeById',
      'startNewPhoneCode': 'icg/startNewPhoneCode'
    }),
    save () {
      this.savePhoneCode(this.locale).then(() => {
        this.$toastr.s('Phone code saved')
        this.startNewPhoneCode().then(() => {
          let newCode = this.$store.state.icg.newPhoneCode
          this.code = Object.assign({}, newCode)
          this.$router.push({name: 'phoneCodes'})
        })
      }).catch((error) => {
        this.$toastr.e(error)
      })
    }
  },
  watch: {
    code: {
      handler (newValue) {
        this.$store.dispatch('icg/setPhoneCode', newValue)
      },
      deep: true
    }
  },
  data () {
    return {
      locale: 'en',
      code: {}
    }
  }
}
</script>

<style lang="scss" scoped>

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}

.add-form {
  max-width: 750px;
}
.submit{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/icg/PhoneCodesEdit.vue